<clmi-message></clmi-message>

@if (getAppIsReady$ | ngrxPush) {
    <wdx-toast
        class="d-block toast-container z-index-999"
        aria-live="polite"
        aria-atomic="true"
    ></wdx-toast>
    @if (isAuthenticated) {
        <organism-engagement-bar></organism-engagement-bar>
    }
    <organism-dynamic-form-modal
        modalId="dynamic-form"
    ></organism-dynamic-form-modal>
    <organism-audit-diff-modal
        modalId="audit-diff-modal"
    ></organism-audit-diff-modal>
    <organism-form-history-modal
        modalId="form-history-modal"
    ></organism-form-history-modal>
    <organism-info-card-check-duplications-modal></organism-info-card-check-duplications-modal>
    <clmi-access-visibility #accessVisibility></clmi-access-visibility>
    <clmi-comments-modal #comments></clmi-comments-modal>
    <router-outlet></router-outlet>
} @else {
    <molecule-loader-overlay></molecule-loader-overlay>
}
